import { useCompareStore } from '@/stores/compareStore';

export function useCompare() {
  const { items, add, remove, toggle, has, clear, isFull } = useCompareStore();
  return { items, add, remove, toggle, has, clear, isFull };
}
